import createCallException from 'utils/backend/createCallException.util';
import asObject from 'utils/objects/asObject.util';

const jsonLineReducer = (message, { non_field_errors: errors }) => (errors ? message + errors.join(' ') : message);

const handleErrorThrow = (options) => {
  const { json, response, ctype } = options ?? {};

  // fail fast scenarios, the first condition met generates the appropriate error to throw

  const { detail, non_field_errors: nonFieldErrors } = asObject(json);
  const { status: code, statusText: text, body } = asObject(response);

  if (detail) throw createCallException({ message: detail, code, body: json, ctype });
  if (text) throw createCallException({ message: text, code, body: json, ctype });
  if (nonFieldErrors) throw createCallException({ message: nonFieldErrors.join(' '), code, body: json, ctype });
  if (!json) throw createCallException({ message: `Unknown error with code ${code}`, code, body, ctype });

  if (Array.isArray(json)) {
    const message = json.reduce(jsonLineReducer, '').trim();
    if (message) throw createCallException({ message, code, body, ctype });
  }

  if (json.error) {
    const message = String(json.error);
    throw createCallException({ message: `Error: ${message}`, code, body: json, ctype });
  }

  throw createCallException({ message: `Error: ${JSON.stringify(json)}`, code, body: json, ctype });
};

export default handleErrorThrow;
